"use client";

import Splash from "../Splash";
import RoomsList from "./RoomsList";
import Featured from "../Featured";
import Introduction from "@/components/Introduction";
import { RoomsOptionsQuery } from "@/types/wordpressQueries";
import { FeaturedComponent } from "@/types/modules";
import { Room } from "@/types/wordpress";
import { useLanguageUrl } from "@/context/languageURLContext";
import { useEffect } from "react";

interface RoomsComponentProps {
  data: RoomsOptionsQuery;
  rooms: Room[];
  language: string;
}

export default function RoomsComponent({
  data,
  rooms,
  language,
}: RoomsComponentProps) {
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(language === "de" ? "/en/rooms" : "/de/rooms");
  }, [language, setUrl]);

  // Sort by isSuite value
  rooms.sort((roomA, roomB) => {
    return roomA.roomsSuite.isSuite === roomB.roomsSuite.isSuite
      ? 0
      : roomA
        ? -1
        : 1;
  });

  const featured: FeaturedComponent = {
    backgroundColor:
      language === "en"
        ? data.roomsOptions.featured.backgroundColor
        : data.roomsOptionsDE.featured.backgroundColor,
    title:
      language === "en"
        ? data.roomsOptions.featured.title
        : data.roomsOptionsDE.featured.title,
    custom:
      language === "en"
        ? data.roomsOptions.featured.custom
        : data.roomsOptionsDE.featured.custom,
  };

  return (
    <>
      {language === "en"
        ? data.roomsOptions.slider &&
          data.roomsOptions.slider.slider && (
            <Splash slider={data.roomsOptions.slider.slider} />
          )
        : data.roomsOptionsDE.slider &&
          data.roomsOptionsDE.slider.slider && (
            <Splash slider={data.roomsOptionsDE.slider.slider} />
          )}
      <Introduction
        title={
          language === "de"
            ? data.roomsOptionsDE.introduction.title
            : data.roomsOptions.introduction.title
        }
        content={
          language === "de"
            ? data.roomsOptionsDE.introduction.content
            : data.roomsOptions.introduction.content
        }
      />
      <RoomsList rooms={rooms} />
      <Featured featured={featured} />
    </>
  );
}
